import { createSlice } from '@reduxjs/toolkit';

interface ILoaderState {
  isLoading: boolean;
};

const initialState: ILoaderState = {
  isLoading: false,
};

const loaderSlicer = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    startLoading: (state: ILoaderState) => {
      state.isLoading = true;
    },
    endLoading: (state: ILoaderState) => {
      state.isLoading = false;
    }
  }
});

export default loaderSlicer.reducer;

export const {
  startLoading,
  endLoading
} = loaderSlicer.actions;